<template>
  <div class="z-service-package-logs">
    <b-list-group flush class="border-bottom">
      <b-list-group-item>
        <div>
          Servicio requerido y creado con éxito
        </div>
        <div class="text-capitalize">
          {{ creationTime }}
        </div>
      </b-list-group-item>
      <b-list-group-item>
        <div>
          Paquetes asignados
        </div>
        <div>
          {{ assignedPackages }}
        </div>
      </b-list-group-item>
      <b-list-group-item>
        <div>
          Paquetes entregados
        </div>
        <div>
          {{ deliveredPackages }}
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { formatISO } from "@zubut/common/src/utils/time";

export default {
  name: "PackageServiceLogs",

  props: {
    service: {
      type: Object,
      required: true
    }
  },

  computed: {
    attempts() {
      return this.service?.additional?.attempts ?? null;
    },
    deliveries() {
      return this.service?.additional?.deliveries ?? null;
    },
    assignedPackages() {
      if (this.attempts !== null && this.deliveries !== null) {
        return this.deliveries + this.attempts;
      }
      return "N/A";
    },
    creationTime() {
      return formatISO(this.service.createdAt, "MMMM dd, yyyy h:mm a");
    },
    deliveredPackages() {
      if (this.deliveries !== null) {
        return this.deliveries;
      }
      return "N/A";
    }
  }
};
</script>

<style lang="scss" scoped>
.z-service-package-logs {
  .list-group-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    padding: 1rem 1rem;
  }
}

@media only screen and (max-width: 768px) {
  .z-service-package-logs {
    .list-group-item {
      font-size: 12px;
      padding: 1rem 0rem;
    }
  }
}
</style>
